import { koerbe, loadProgress, type KorbId } from '@/core/progress'
import { useSettings } from './settings'

export interface KoerbeProps {
  /** Wird mit dem gewählten Korb gerufen; der Abschnitt zieht dann daraus seine Karten. */
  onKorb: (korb: KorbId) => void
  /** Welcher Korb gerade geübt wird. */
  aktiv?: KorbId
}

const REIHE: { id: KorbId; titel: string }[] = [
  { id: 'fehler', titel: 'korb.fehler' },
  { id: 'wackelt', titel: 'korb.wackelt' },
  { id: 'neu', titel: 'korb.neu' },
  { id: 'sitzt', titel: 'korb.sitzt' },
]

/**
 * Wo du stehst, und was als Nächstes dran ist, in einem Element.
 *
 * Jeder Korb nennt seine Zahl und ist ein Knopf. Der Fehlerkorb steht vorn, weil er die
 * beste nächste Handlung ist: was zuletzt falsch war, sitzt am wenigsten. Ein leerer Korb
 * bleibt sichtbar, aber ohne Knopfwirkung, damit die Zahlen vergleichbar bleiben und
 * nicht die Reihenfolge springt.
 */
export function Koerbe({ onKorb, aktiv }: KoerbeProps) {
  const { t, settings } = useSettings()
  const stand = koerbe(loadProgress(), settings.bereich)

  return (
    <div className="koerbe" data-testid="koerbe">
      {REIHE.map((eintrag) => {
        const korb = stand.find((k) => k.id === eintrag.id)!
        const leer = korb.karten.length === 0
        return (
          <button
            key={korb.id}
            type="button"
            className={`korb${aktiv === korb.id ? ' korb--on' : ''}`}
            data-korb={korb.id}
            data-anzahl={korb.karten.length}
            data-testid={`korb-${korb.id}`}
            disabled={leer}
            onClick={() => onKorb(korb.id)}
          >
            <span className="korb__zahl">{korb.karten.length}</span>
            <span className="korb__titel">{t(eintrag.titel as never)}</span>
          </button>
        )
      })}
    </div>
  )
}
